<form [formGroup]="ContactFormGroup">

  <div>
    <br />
    <b style="color: #477c93;"> Contact details</b>
    <div class="-divider dropdown-divider" style="border: 1px solid #348cd4"></div>
    <br />
  </div>

  <div class="row form-horizontal">
    <div class="col-md-6 form-horizontal px-3">
      <div>
        <div class="form-group row">
          <label for="firstName" class="col-4 col-form-label">Contact Name</label>
          <div class="col-8">
            <input formControlName="firstName" class="form-control" id="firstName" placeholder="Contact name">
            <ul *ngIf="submitted || this.ContactFormGroup.controls['firstName'].dirty || this.ContactFormGroup.controls['firstName'].touched" class="parsley-errors-list filled">
              <li *ngIf="ContactFormGroup.controls['firstName'].value == ''" class="parsley-required">Contact name is required.</li>
            </ul>
          </div>
        </div>

        <div class="form-group row">
          <label for="surname" class="col-4 col-form-label">Contact Surname</label>
          <div class="col-8">
            <input formControlName="surname" class="form-control" id="surname" placeholder="Contact surname">
            <ul *ngIf="submitted || this.ContactFormGroup.controls['surname'].dirty || this.ContactFormGroup.controls['surname'].touched" class="parsley-errors-list filled">
              <li *ngIf="ContactFormGroup.controls['surname'].value == ''" class="parsley-required">Contact surname is required.</li>
            </ul>
          </div>
        </div>

        <div class="form-group row">
          <label for="workNumber" class="col-4 col-form-label">Work Number</label>
          <div class="col-8">
            <input formControlName="workNumber" class="form-control" id="workNumber" placeholder="Work number">
            <ul *ngIf="submitted || this.ContactFormGroup.controls['workNumber'].dirty || this.ContactFormGroup.controls['workNumber'].touched" class="parsley-errors-list filled">
              <li *ngIf="ContactFormGroup.controls['workNumber'].value == ''" class="parsley-required">Work nummber is required.</li>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <div class="col-md-6 form-horizontal px-3">

      <div class="form-group row">
        <label for="mobileNumber" class="col-4 col-form-label">Cell Number</label>
        <div class="col-8">
          <input formControlName="mobileNumber" class="form-control" id="mobileNumber" placeholder="Cell number">
          <ul *ngIf="submitted || this.ContactFormGroup.controls['mobileNumber'].dirty || this.ContactFormGroup.controls['mobileNumber'].touched" class="parsley-errors-list filled">
            <li *ngIf="ContactFormGroup.controls['mobileNumber'].value == ''" class="parsley-required">Cell nummber is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="emailAddress" class="col-4 col-form-label">Email Address</label>
        <div class="col-8">
          <textarea rows="3" formControlName="emailAddress" class="form-control" id="emailAddress" placeholder="Email address"></textarea>
          <ul *ngIf="submitted || this.ContactFormGroup.controls['emailAddress'].dirty || this.ContactFormGroup.controls['emailAddress'].touched" class="parsley-errors-list filled">
            <li *ngIf="ContactFormGroup.controls['emailAddress'].value == ''" class="parsley-required">Emai address is required.</li>
          </ul>
        </div>
      </div>

      <div class="form-group row">
        <label for="mobileNumber" class="col-4 col-form-label">Url</label>
        <div class="col-8">
          <input formControlName="url" class="form-control" id="url" placeholder="i.e acs-sa.com">
          <ul *ngIf="submitted || this.ContactFormGroup.controls['url'].dirty || this.ContactFormGroup.controls['url'].touched" class="parsley-errors-list filled">
            <li *ngIf="ContactFormGroup.controls['url'].value == ''" class="parsley-required">URL is required.</li>
          </ul>
        </div>
      </div>

    </div>
  </div>
</form>
